import { render, staticRenderFns } from "./confirmPoints.vue?vue&type=template&id=6f0bd042&scoped=true&"
import script from "./confirmPoints.vue?vue&type=script&lang=js&"
export * from "./confirmPoints.vue?vue&type=script&lang=js&"
import style0 from "./confirmPoints.vue?vue&type=style&index=0&id=6f0bd042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0bd042",
  null
  
)

export default component.exports